module.exports = __webpack_public_path__ + "static/img/enterprise-big-1.575c78d5.png";